// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e5c5c354","453":"cfd59cba","732":"442aaf75"}[chunkId] + ".chunk.js";
};